module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    attrs: {
      "id": ("chart-container-" + _vm.id)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16da8a01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OperatorActivityChart.vue
// module id = 519
// module chunks = 0